<template>
  <div ref="container" style="position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto;"
       :style="{ width: width, height: height }"
  >
  </div>
</template>
<script>
import * as echarts from 'echarts/core'
import resizeMixin from './resizeMixin'
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  DataZoomComponent
} from 'echarts/components'
import { BarChart } from 'echarts/charts'
import { SVGRenderer } from 'echarts/renderers'

echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  DataZoomComponent,
  BarChart,
  SVGRenderer
])

export default {
  name: 'GaugeChart',
  mixins: [resizeMixin],
  props: {
    viewModel: {
      type: Array,
      default () {
        return []
      }
    },
    propMap: {
      type: Object,
      default () {
        return {
          xAxis: 'date'
        }
      }
    },
    height: {
      type: String,
      default () {
        return '100%'
      }
    },
    width: {
      type: String,
      default () {
        return '100%'
      }
    },
    tooltipFormater: {
      type: [String, Function],
      default () {
        return undefined
      }
    },
    tooltipClass: {
      type: String,
      default () {
        return undefined
      }
    },
    twoYaxis: {
      type: Boolean,
      default () {
        return false
      }
    },
    custYaxis: {
      type: Array,
      default () {
        return [{
          type: 'value'
        }]
      }
    },
    dataZoom: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  data () {
    return {
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          top: '16%',
          right: '6%',
          bottom: '4%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            nameTextStyle: {
              width: 60,
              overflow: 'truncate'
            },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
        ]
      }
    }
  },
  mounted () {
    if (this.tooltipFormater) {
      this.option.tooltip.formatter = this.tooltipFormater
    }
    if (this.tooltipClass) {
      this.option.tooltip.className = this.tooltipClass
    }
    if (this.twoYaxis) {
      this.option.yAxis = this.custYaxis
    }
    if (this.dataZoom) {
      this.option.dataZoom = [
        {
          show: false,
          start: 0,
          end: this.dataZoom
        },
        {
          type: 'inside',
          start: 0,
          end: this.dataZoom
        }
      ]
    }
    this.$nextTick(() => {
      const chartDom = this.$refs.container
      this.chart = echarts.init(chartDom)
      this.updateData()
    })
  },
  updated () {
    this.updateData()
  },
  methods: {
    updateData () {
      const series = []
      const { xAxis, spliter } = this.propMap
      for (const prop in this.propMap) {
        this.option.xAxis[0].data = this.viewModel.map(t => t[xAxis])
        if (prop !== 'xAxis' && prop !== 'spliter') {
          const serieData = this.viewModel.map(t => t[prop] || 0)
          const stackBarName = this.propMap[prop].split(spliter)
          let yAxisIndex = 0
          if (this.twoYaxis) {
            yAxisIndex = this.custYaxis.findIndex(t => ~t.stack.indexOf(stackBarName[0]))
          }
          if (stackBarName.length === 2) {
            series.push({
              name: stackBarName[1],
              type: 'bar',
              stack: stackBarName[0],
              emphasis: {
                focus: 'series'
              },
              yAxisIndex,
              data: serieData
            })
          } else {
            series.push({
              name: this.propMap[prop],
              type: 'bar',
              emphasis: {
                focus: 'series'
              },
              yAxisIndex,
              data: serieData
            })
          }
        }
      }
      this.option.series = series
      this.chart.setOption(this.option)
    }
  }
}
</script>
